import moment from 'moment'
import { COLOR_PALETTE } from '../constants/theme'
import { buildDropdownList } from './app/app.helpers'
import {
  exceedLimitRule,
  requiredRule,
  validFutureTimeRule
} from './validation.helpers'
import { buildPaginationFilters } from './epics.helpers'
import { toKebabCase } from './string.helpers'

const UNIQUE_CAMPAIGN_MAX_SUPPLY = 1000
const CAMPAIGN_TYPE_OPTIONS = {
  ONE: 'one',
  UNIQUE: 'unique'
}

const CAMPAIGN_STATUS_OPTIONS = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive'
}

const buildCampaignStatusOptions = (t) => {
  return buildDropdownList(
    CAMPAIGN_STATUS_OPTIONS,
    'campaign.campaign-status-types',
    t
  )
}

const buildCampaignTypeOptions = (t) => {
  return buildDropdownList(CAMPAIGN_TYPE_OPTIONS, 'campaign.code-type', t)
}

const buildCampaignValidationRules = ({
  nameTemp,
  valueTemp,
  supplyTemp,
  typeTemp,
  validUntilTemp
}) => {
  return {
    nameTemp: {
      value: nameTemp,
      rules: [requiredRule]
    },
    valueTemp: { value: valueTemp, rules: [requiredRule] },
    supplyTemp: {
      value: supplyTemp,
      rules: [
        requiredRule,
        ...(typeTemp === CAMPAIGN_TYPE_OPTIONS.UNIQUE
          ? [exceedLimitRule(UNIQUE_CAMPAIGN_MAX_SUPPLY, 'campaign.max-supply')]
          : [])
      ]
    },
    typeTemp: { value: typeTemp, rules: [requiredRule] },
    validUntilTemp: {
      value: validUntilTemp,
      rules: [
        requiredRule,
        validFutureTimeRule(null, 'campaign.active-until-cannot-be-past')
      ]
    }
  }
}

const campaignCreateFieldsFormat = (state) => {
  const campaignProfile = extractCampaignProfile(state)
  const { nameTemp, valueTemp, supplyTemp, typeTemp, validUntilTemp } =
    campaignProfile
  return campaignDataObjFormat({
    status: CAMPAIGN_STATUS_OPTIONS.ACTIVE,
    name: nameTemp,
    value: parseInt(valueTemp),
    supply: parseInt(supplyTemp),
    unique_codes: typeTemp === CAMPAIGN_TYPE_OPTIONS.UNIQUE,
    valid_until: moment.utc(validUntilTemp).format()
  })
}

const campaignDataObjFormat = (data) => {
  return {
    campaign: {
      ...data
    }
  }
}

const buildStatusLabelColor = (status) => {
  if (status === CAMPAIGN_STATUS_OPTIONS.ACTIVE) {
    return COLOR_PALETTE.SUCCESS
  }
  return COLOR_PALETTE.ERROR
}

const campaignTableHeaders = (symbol) => {
  return [
    {
      value: 'name',
      label: 'common.description',
      sx: { width: '25%' }
    },
    {
      value: 'reward-code',
      label: 'campaign.reward-code'
    },
    {
      value: 'reward-in',
      label: 'campaign.reward-in',
      args: { symbol }
    },
    {
      value: 'supply',
      label: 'nft.supply'
    },
    {
      value: 'status',
      label: 'common.status',
      sx: { minWidth: 80 }
    },
    {
      value: 'active-until',
      label: 'campaign.active-until'
    },
    {
      value: 'actions',
      label: 'common.actions',
      sx: { textAlign: 'center' }
    }
  ]
}

const extractCampaignReducer = (state) => {
  return state.value.campaignReducer
}

const extractCampaignProfile = (state) => {
  return extractCampaignReducer(state).campaignProfile
}

const extractCampaignListProfile = (state) => {
  return extractCampaignReducer(state).campaignListProfile
}

const buildCampaignPaginationFilters = (payload, state) => {
  const { pagination, status } = extractCampaignListProfile(state)
  return {
    ...buildPaginationFilters(payload, pagination),
    ...(status !== CAMPAIGN_STATUS_OPTIONS.ALL && { status })
  }
}

const buildCodesDownloadForReportEmail = (brandId, { id, name }) => {
  return {
    brand_id: brandId,
    campaign_id: id,
    filename: `${toKebabCase(name, '_')}_codes`
  }
}

export {
  UNIQUE_CAMPAIGN_MAX_SUPPLY,
  CAMPAIGN_TYPE_OPTIONS,
  CAMPAIGN_STATUS_OPTIONS,
  buildCampaignStatusOptions,
  buildCampaignTypeOptions,
  buildCampaignValidationRules,
  campaignCreateFieldsFormat,
  campaignDataObjFormat,
  buildStatusLabelColor,
  campaignTableHeaders,
  extractCampaignListProfile,
  extractCampaignProfile,
  buildCampaignPaginationFilters,
  buildCodesDownloadForReportEmail
}
